

























































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import MailboxVerificationPopupEmailViewer from '../components/mailbox-verification-popup-email-viewer.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'MailboxVerificationInstructionsNoProvider',
  components: {
    MailboxVerificationPopupEmailViewer,
  },
  props: {
    incomingEmailAddress: {
      type: String,
      required: true,
    },
    forwardingFromAddress: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ColorAssistant,
      showVerificationPopup: false,
    }
  },
})
